(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-flow-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rr-flow-carousel')) {
    customElements.define('rr-flow-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.current = 0;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.current - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1));
        this.querySelectorAll('[data-select]').forEach((button, index) => button.addEventListener('click', () => this.show(index)));
        this.dots.forEach((button, index) => button.addEventListener('click', () => this.show(index)));
        this.show(0);
      }

      show(index) {
        const count = this.slides.length;
        if (!count) return;
        this.current = (index + count) % count;
        this.slides.forEach((slide, slideIndex) => {
          let offset = slideIndex - this.current;
          if (offset > Math.floor(count / 2)) offset -= count;
          if (offset < -Math.floor(count / 2)) offset += count;
          slide.dataset.offset = Math.abs(offset) > 1 ? 'hidden' : String(offset);
          slide.setAttribute('aria-hidden', offset === 0 ? 'false' : 'true');
          slide.querySelector('[data-select]').tabIndex = Math.abs(offset) <= 1 ? 0 : -1;
        });
        this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === this.current ? 'true' : 'false'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-product-editorial"] && !Shopify.designMode) return;
  try {
    
  const initRRProduct = (root) => {
    if (root.dataset.rrReady === 'true') return;
    root.dataset.rrReady = 'true';
    const variantsNode = root.querySelector('[data-rr-variants]');
    if (!variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const groups = [...root.querySelectorAll('[data-rr-option-group]')];
    const variantInput = root.querySelector('[data-rr-variant-id]');
    const addButton = root.querySelector('[data-rr-add]');
    const addText = root.querySelector('[data-rr-add-text]');
    const price = root.querySelector('[data-rr-price]');
    const comparePrice = root.querySelector('[data-rr-compare-price]');
    const leadImage = root.querySelector('.rr-product__lead-image');
    const quantity = root.querySelector('[data-rr-quantity]');
    const currency = root.dataset.currency || 'USD';
    const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);

    const selectedOptions = () => groups.map((group) => group.querySelector('[data-rr-option]:checked')?.value || '');
    const findVariant = () => {
      const selected = selectedOptions();
      return variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
    };
    const refreshAvailability = () => {
      const selected = selectedOptions();
      groups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-rr-option]').forEach((input) => {
          const possible = variants.some((variant) => variant.available && variant.options.every((value, index) => index === groupIndex ? value === input.value : !selected[index] || value === selected[index]));
          input.disabled = !possible;
        });
      });
    };
    const update = () => {
      groups.forEach((group) => {
        const checked = group.querySelector('[data-rr-option]:checked');
        const label = group.querySelector('[data-rr-option-label]');
        if (checked && label) label.textContent = checked.value;
      });
      const variant = findVariant();
      if (!variant) {
        addButton.disabled = true;
        addText.textContent = 'Unavailable';
        return;
      }
      variantInput.value = variant.id;
      price.textContent = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePrice.hidden = false;
        comparePrice.textContent = money(variant.compare_at_price);
      } else {
        comparePrice.hidden = true;
      }
      addButton.disabled = !variant.available;
      addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (leadImage && variant.featured_image?.src) {
        leadImage.src = variant.featured_image.src;
        leadImage.removeAttribute('srcset');
      }
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', nextUrl);
      refreshAvailability();
    };
    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-rr-option]')) update();
    });
    root.querySelector('[data-rr-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) - 1); });
    root.querySelector('[data-rr-quantity-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value) + 1; });
    refreshAvailability();
  };
  document.querySelectorAll('[data-rr-product]').forEach(initRRProduct);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-rr-product]').forEach(initRRProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-product-nav"] && !Shopify.designMode) return;
  try {
    
  const initRRProductHeader = () => {
    if (!document.querySelector('main[data-template="product.rr-editorial"]')) return;
    const body = document.body;
    const pageWrapper = document.querySelector('.page-wrapper');
    const updateHeader = () => {
      const scrollTop = Math.max(window.scrollY, document.documentElement.scrollTop, pageWrapper?.scrollTop || 0);
      body.classList.toggle('rr-product-scrolled', scrollTop > 18);
    };
    if (body.dataset.rrProductHeaderReady !== 'true') {
      body.dataset.rrProductHeaderReady = 'true';
      window.addEventListener('scroll', updateHeader, { passive: true });
      pageWrapper?.addEventListener('scroll', updateHeader, { passive: true });
    }
    updateHeader();
  };
  initRRProductHeader();
  document.addEventListener('shopify:section:load', initRRProductHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-product-opening"] && !Shopify.designMode) return;
  try {
    
  const initRROpening = (root) => {
    if (root.dataset.rrOpeningReady === 'true') return;
    root.dataset.rrOpeningReady = 'true';
    const variantsNode = root.querySelector('[data-rr-variants]');
    if (!variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const variantMediaNode = root.querySelector('[data-rr-variant-media]');
    const variantMedia = variantMediaNode ? JSON.parse(variantMediaNode.textContent) : {};
    const groups = [...root.querySelectorAll('[data-rr-option-group]')];
    const colorGroupIndex = groups.findIndex((group) => group.hasAttribute('data-rr-color-group'));
    const sizeGroupIndex = groups.findIndex((group) => group.hasAttribute('data-rr-size-group'));
    const variantInput = root.querySelector('[data-rr-variant-id]');
    const addButton = root.querySelector('[data-rr-add]');
    const addText = root.querySelector('[data-rr-add-text]');
    const prices = [...root.querySelectorAll('[data-rr-price]')];
    const comparePrices = [...root.querySelectorAll('[data-rr-compare-price]')];
    const quantity = root.querySelector('[data-rr-quantity]');
    const mediaViewer = root.querySelector('[data-rr-media-viewer]');
    const mediaSlides = [...root.querySelectorAll('[data-rr-media-slide]')];
    const mediaThumbs = [...root.querySelectorAll('[data-rr-media-thumb]')];
    const mediaCounter = root.querySelector('[data-rr-media-current]');
    const heroPrevious = root.querySelector('[data-rr-hero-previous]');
    const heroNext = root.querySelector('[data-rr-hero-next]');
    const mediaRail = root.querySelector('[data-rr-media-rail]');
    const previousMedia = root.querySelector('[data-rr-media-previous]');
    const nextMedia = root.querySelector('[data-rr-media-next]');
    const currency = root.dataset.currency || 'USD';
    const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    let activeMediaIndex = Math.max(0, mediaSlides.findIndex((slide) => !slide.hidden));
    const pauseInactiveMedia = () => {
      mediaSlides.forEach((slide, index) => {
        if (index === activeMediaIndex) return;
        slide.querySelectorAll('video').forEach((video) => video.pause());
      });
    };
    const showMedia = (mediaReference, scrollThumbnail = true) => {
      if (!mediaSlides.length) return;
      let nextIndex = Number(mediaReference);
      const referencedSlide = mediaSlides.find((slide) => slide.dataset.mediaId === String(mediaReference));
      if (referencedSlide) nextIndex = Number(referencedSlide.dataset.mediaIndex);
      if (!Number.isFinite(nextIndex)) return;
      nextIndex = (nextIndex + mediaSlides.length) % mediaSlides.length;
      activeMediaIndex = nextIndex;
      mediaSlides.forEach((slide, index) => { slide.hidden = index !== activeMediaIndex; });
      mediaThumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === activeMediaIndex)));
      if (mediaCounter) mediaCounter.textContent = String(activeMediaIndex + 1);
      pauseInactiveMedia();
      const selectedThumb = mediaThumbs[activeMediaIndex];
      if (scrollThumbnail && mediaRail && selectedThumb) {
        const targetLeft = selectedThumb.offsetLeft - ((mediaRail.clientWidth - selectedThumb.offsetWidth) / 2);
        mediaRail.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      }
    };
    const stepMedia = (direction) => showMedia(activeMediaIndex + direction);
    const selectedOptions = () => groups.map((group) => group.querySelector('[data-rr-option]:checked')?.value || '');
    const findVariant = () => {
      const selected = selectedOptions();
      return variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
    };
    const refreshAvailability = () => {
      const selected = selectedOptions();
      groups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-rr-option]').forEach((input) => {
          if (groupIndex === colorGroupIndex) {
            input.disabled = false;
            const soldOut = !variants.some((variant) => variant.available && variant.options[groupIndex] === input.value);
            input.dataset.rrSoldOut = String(soldOut);
            input.setAttribute('aria-label', soldOut ? `${input.value}, ${root.dataset.textSoldOut}` : input.value);
            return;
          }
          input.disabled = !variants.some((variant) => variant.available && variant.options.every((value, index) => index === groupIndex ? value === input.value : !selected[index] || value === selected[index]));
        });
      });
    };
    const clearUnavailableSize = () => {
      if (sizeGroupIndex < 0) return;
      const sizeInput = groups[sizeGroupIndex].querySelector('[data-rr-option]:checked');
      if (!sizeInput) return;
      const selected = selectedOptions();
      const sizeStillAvailable = variants.some((variant) => variant.available && variant.options.every((value, index) => index === sizeGroupIndex ? value === sizeInput.value : !selected[index] || value === selected[index]));
      if (!sizeStillAvailable) sizeInput.checked = false;
    };
    const displayVariantFor = (selected) => {
      const matches = variants.filter((variant) => variant.options.every((value, index) => !selected[index] || value === selected[index]));
      return matches.find((variant) => variant.available && variantMedia[String(variant.id)])
        || matches.find((variant) => variantMedia[String(variant.id)])
        || matches.find((variant) => variant.available)
        || matches[0];
    };
    const update = () => {
      groups.forEach((group) => {
        const checked = group.querySelector('[data-rr-option]:checked');
        const label = group.querySelector('[data-rr-option-label]');
        if (label) label.textContent = checked ? checked.value : '';
      });
      const selected = selectedOptions();
      const variant = findVariant();
      const displayVariant = variant || displayVariantFor(selected);
      variantInput.value = variant ? variant.id : '';
      if (displayVariant) {
        prices.forEach((price) => { price.textContent = money(displayVariant.price); });
        if (displayVariant.compare_at_price && displayVariant.compare_at_price > displayVariant.price) {
          comparePrices.forEach((comparePrice) => {
            comparePrice.hidden = false;
            comparePrice.textContent = money(displayVariant.compare_at_price);
          });
        } else {
          comparePrices.forEach((comparePrice) => { comparePrice.hidden = true; });
        }
        const featuredMediaId = variantMedia[String(displayVariant.id)];
        if (featuredMediaId) showMedia(featuredMediaId);
      }
      addButton.disabled = !variant || !variant.available;
      if (variant) {
        addText.textContent = variant.available ? root.dataset.textAdd : root.dataset.textSoldOut;
      } else if (sizeGroupIndex >= 0 && !selected[sizeGroupIndex]) {
        const hasAvailableSize = variants.some((candidate) => candidate.available && candidate.options.every((value, index) => index === sizeGroupIndex || !selected[index] || value === selected[index]));
        addText.textContent = hasAvailableSize ? root.dataset.textChooseSize : root.dataset.textSoldOut;
      } else {
        addText.textContent = root.dataset.textUnavailable;
      }
      const nextUrl = new URL(window.location.href);
      if (variant) nextUrl.searchParams.set('variant', variant.id);
      else nextUrl.searchParams.delete('variant');
      window.history.replaceState({}, '', nextUrl);
      refreshAvailability();
    };
    root.addEventListener('change', (event) => {
      if (!event.target.matches('[data-rr-option]')) return;
      if (event.target.closest('[data-rr-color-group]')) clearUnavailableSize();
      update();
    });
    variantInput.closest('form')?.addEventListener('submit', (event) => {
      if (!variantInput.value || addButton.disabled) event.preventDefault();
    });
    root.addEventListener('click', (event) => {
      const mediaThumb = event.target.closest('[data-rr-media-thumb]');
      if (mediaThumb) showMedia(mediaThumb.dataset.mediaId);
    });
    heroPrevious?.addEventListener('click', () => stepMedia(-1));
    heroNext?.addEventListener('click', () => stepMedia(1));
    if (mediaViewer && mediaSlides.length > 1) {
      let touchStartX = 0;
      let touchStartY = 0;
      mediaViewer.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
        touchStartY = event.changedTouches[0]?.clientY || 0;
      }, { passive: true });
      mediaViewer.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;
        const distanceX = touch.clientX - touchStartX;
        const distanceY = touch.clientY - touchStartY;
        if (Math.abs(distanceX) > 48 && Math.abs(distanceX) > Math.abs(distanceY)) stepMedia(distanceX < 0 ? 1 : -1);
      }, { passive: true });
    }
    root.querySelector('[data-rr-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) - 1); });
    root.querySelector('[data-rr-quantity-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value) + 1; });
    if (mediaRail) {
      const updateMediaButtons = () => {
        const end = mediaRail.scrollWidth - mediaRail.clientWidth;
        if (previousMedia) previousMedia.disabled = mediaRail.scrollLeft <= 2;
        if (nextMedia) nextMedia.disabled = mediaRail.scrollLeft >= end - 2;
      };
      previousMedia?.addEventListener('click', () => stepMedia(-1));
      nextMedia?.addEventListener('click', () => stepMedia(1));
      mediaRail.addEventListener('scroll', updateMediaButtons, { passive: true });
      window.addEventListener('resize', updateMediaButtons);
      updateMediaButtons();
    }
    showMedia(activeMediaIndex, false);
    refreshAvailability();
  };
  document.querySelectorAll('[data-rr-opening]').forEach(initRROpening);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-rr-opening]').forEach(initRROpening));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-share-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', function(event) {
  const disclosure = event.target.closest('.rs-form-disclosure');
  if (disclosure) disclosure.open = true;
});

  } catch(e) { console.error(e); }
})();
})();
